// Module
var code = `<div class="batch-convert">
    <div class="main-layout">
        <!-- Left: Upload & Configure Panel -->
        <div class="config-panel">
            <div class="card h-100">
                <div class="card-header">
                    <h5>Batch Upload & Configure</h5>
                </div>
                <div class="card-body">
                    <!-- Upload Area -->
                    <div class="upload-area" id="uploadArea">
                        <input type="file" id="fileInput" accept=".txt,.ds,.ds.txt,.srt" multiple style="display:none" />
                        <div class="upload-prompt">
                            <i class="upload-icon">📁</i>
                            <p>Drag & drop files here or click to browse</p>
                            <small class="text-muted">Supported: .txt, .ds, .srt (multiple files)</small>
                        </div>
                    </div>

                    <!-- Options Panel (shown after file upload) -->
                    <div class="options-panel" id="optionsPanel" style="display:none">
                        <div class="mb-3">
                            <label class="form-label">Files Selected</label>
                            <div class="alert alert-secondary" id="fileCount">0 files</div>
                        </div>

                        <div class="mb-3">
                            <label for="sourceFormat" class="form-label">Source Format</label>
                            <select id="sourceFormat" class="form-select" required>
                                <option value="">-- Select Source Format --</option>
                                <option value="Text">Plain Text</option>
                                <option value="SRT">SRT</option>
                                <option value="AvidDS">Avid DS</option>
                            </select>
                        </div>

                        <div class="mb-3">
                            <label for="targetFormat" class="form-label">Target Format</label>
                            <select id="targetFormat" class="form-select" required>
                                <option value="">-- Select Target Format --</option>
                            </select>
                        </div>

                        <div class="mb-3" id="frameRateGroup" style="display:none">
                            <label for="frameRate" class="form-label">Frame Rate</label>
                            <select id="frameRate" class="form-select">
                                <option value="">Default (25fps)</option>
                            </select>
                        </div>

                        <div class="mb-3" id="modeGroup" style="display:none">
                            <label for="mode" class="form-label">Parser Mode</label>
                            <select id="mode" class="form-select">
                                <option value="">Default (AvidDS)</option>
                                <option value="AvidDS">Avid DS</option>
                            </select>
                        </div>

                        <div class="form-check mb-3">
                            <input type="checkbox" id="ignoreFrames" class="form-check-input" />
                            <label for="ignoreFrames" class="form-check-label">Ignore Frames</label>
                        </div>

                        <!-- Action Buttons -->
                        <div class="actions">
                            <button type="button" id="convertBtn" class="btn btn-success w-100 mb-2">
                                <span class="btn-text">Convert All</span>
                                <span class="spinner-border spinner-border-sm d-none" role="status"></span>
                            </button>
                            <button type="button" id="downloadBtn" class="btn btn-primary w-100 mb-2" style="display:none">
                                Download ZIP
                            </button>
                            <button type="button" id="clearBtn" class="btn btn-outline-secondary w-100">
                                Clear & Start Over
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Right: File List & Progress -->
        <div class="files-area">
            <!-- File List -->
            <div class="card">
                <div class="card-header">
                    <h5>Files to Convert</h5>
                </div>
                <div class="card-body">
                    <!-- Placeholder -->
                    <div id="placeholderCard">
                        <div class="text-center text-muted">
                            <p class="lead">Upload files to begin batch conversion</p>
                            <small>No validation will be performed. Files will be converted as-is.</small>
                        </div>
                    </div>

                    <!-- File List -->
                    <div id="fileList" style="display:none">
                        <div class="table-responsive">
                            <table class="table table-sm table-hover">
                                <thead>
                                    <tr>
                                        <th>Filename</th>
                                        <th>Size</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody id="fileListBody">
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Progress Panel -->
            <div class="card mt-3" id="progressCard" style="display:none">
                <div class="card-header">
                    <h5>Conversion Progress</h5>
                </div>
                <div class="card-body">
                    <div class="progress mb-2">
                        <div id="progressBar" class="progress-bar progress-bar-striped progress-bar-animated" 
                             role="progressbar" style="width: 0%">0%</div>
                    </div>
                    <p id="progressText" class="text-muted mb-0">Ready to convert</p>
                </div>
            </div>

            <!-- Results Summary -->
            <div class="card mt-3" id="resultsCard" style="display:none">
                <div class="card-header">
                    <h5>Conversion Results</h5>
                </div>
                <div class="card-body">
                    <div id="resultsContent"></div>
                </div>
            </div>
        </div>
    </div>
</div>
`;
// Exports
export default code;